import UsersRouting from 'modules/settings/users/users-routing';
import { Role } from './roles';
import PharmacySettings from 'modules/settings/pharmacy-settings/pharmacy-settings';
import VehiclesRouting from 'modules/settings/vehicles/vehicles-routing';
import LocationsRouting from 'modules/settings/locations/locations-routing';
import SubLocationsRouting from 'modules/settings/sub-locations/sub-locations-routing';
import ProcessTypesList from 'modules/settings/process-types/process-types-list';
import ProcessTypeStatusesList from 'modules/settings/process-type-statuses/process-type-statuses-list';
import VehicleCheckSettingsList from 'modules/settings/vehicle-check-settings/vehicle-check-settings-list';
import RunsSettingsRouting from 'modules/settings/runs/runs-setting-routing';
import LogisticsSettingsOverview from 'modules/settings/logistics-settings-overview/logistics-settings-overview';
import TransportSettings from 'modules/settings/transport-settings/transport-settings';
import DeliveryRequestRouting from 'modules/settings/delivery-request-routing/delivery-request-routing';

export const SettingsOptions = [
  {
    label: 'Pharmacy Settings',
    route: 'pharmacy-settings',
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN],
    element: <PharmacySettings />,
  },
  {
    label: 'Logistics Settings',
    route: 'logistics-settings',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <LogisticsSettingsOverview />,
  },
  {
    label: 'Transport Settings',
    route: 'transport-settings',
    roles: [Role.SUPER_ADMIN, Role.TRANSPORT_ADMIN],
    element: <TransportSettings />,
  },
  {
    // The table decides what happens to every inbound Delivery Request, so it
    // is restricted to the same roles the backend enforces.
    label: 'Delivery Request Routing',
    route: 'delivery-request-routing',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <DeliveryRequestRouting />,
  },
  {
    label: 'Users',
    route: 'users',
    roles: [Role.SUPER_ADMIN],
    element: <UsersRouting />,
  },
  {
    label: 'Runs',
    route: 'runs',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <RunsSettingsRouting />,
  },
  {
    label: 'Vehicles',
    route: 'vehicles',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <VehiclesRouting />,
  },
  {
    label: 'Vehicle Checks',
    route: 'vehicle-checks',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <VehicleCheckSettingsList />,
  },
  {
    label: 'Locations',
    route: 'locations',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <LocationsRouting />,
  },
  {
    label: 'Sub Locations',
    route: 'sub-locations',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <SubLocationsRouting />,
  },
  {
    label: 'Process Types',
    route: 'process-types',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <ProcessTypesList />,
  },
  {
    label: 'Process Type Statuses',
    route: 'process-type-statuses',
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN],
    element: <ProcessTypeStatusesList />,
  },
];
